// @ts-strict

import { Component, Output, Input, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-circle-buttons',
  templateUrl: './circle-buttons.component.html',
  styleUrls: ['./circle-buttons.component.scss']
})
export class CircleButtonsComponent {
  @Input() icon?: string;
  @Input() iconSize?: string;
  @Input() grayIcon = false;
  @Input() borderButton = false;
  @Input() cancelButton = false;
  @Input() greenButton = false;
  @Input() biggerButton = false;
  @Input() closeModalButton = false;
  @Output() emitAction = new EventEmitter<void>();

  performAction(): void {
    this.emitAction.emit();
  }
}
